import { render, staticRenderFns } from "./lianjiebao.vue?vue&type=template&id=7cfecafa&scoped=true"
import script from "./lianjiebao.vue?vue&type=script&lang=js"
export * from "./lianjiebao.vue?vue&type=script&lang=js"
import style0 from "./lianjiebao.vue?vue&type=style&index=0&id=7cfecafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfecafa",
  null
  
)

export default component.exports